import { all, fork, takeLatest, call, put } from "redux-saga/effects";

import { getPermissionAPI } from "api/permission";
import { getPermissionSuccess, getPermissionError } from "./actions";
import { GET_PERMISSION } from "./constants";

function* watchGetPermission() {
  yield takeLatest(GET_PERMISSION, function* (action) {
    const params = action.payload || {};
    const response = yield call(getPermissionAPI, params);
    if (response.status) {
      yield put(getPermissionSuccess(response.data));
    } else {
      yield put(
        getPermissionError({
          msg: "Get permission error!",
          msgId: "notification.get-permission-error",
        })
      );
    }
  });
}

export default function* permissionSaga() {
  yield all([fork(watchGetPermission)]);
}
